import { CalendarCheck, Truck, FileCheck, CheckCircle2 } from 'lucide-react'
import { cn } from '@/lib/utils'

const steps = [
  {
    id: 1,
    title: 'Agendamento',
    description: 'Definimos a frequência de coleta ideal para sua demanda.',
    icon: CalendarCheck,
  },
  {
    id: 2,
    title: 'Coleta',
    description: 'Nossa equipe realiza a coleta técnica no local.',
    icon: Truck,
  },
  {
    id: 3,
    title: 'Documentação',
    description: 'Emissão e rastreamento via MTR online.',
    icon: FileCheck,
  },
  {
    id: 4,
    title: 'Certificação',
    description: 'Emissão do Certificado de Destinação Final (CDF).',
    icon: CheckCircle2,
  },
]

export const Process = () => {
  return (
    <section id="process" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Como Funciona
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Um processo simplificado e transparente para que você foque no que
            realmente importa. <br />O seu negócio!
          </p>
        </div>

        <div className="relative">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-200 -translate-y-1/2 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10">
            {steps.map((step, index) => (
              <div
                key={step.id}
                className="flex flex-col items-center text-center group"
              >
                <div
                  className={cn(
                    'w-16 h-16 rounded-full border-4 border-white shadow-lg flex items-center justify-center mb-6 transition-colors duration-300',
                    'bg-white text-gray-400 group-hover:bg-primary group-hover:text-white group-hover:scale-110 transform',
                  )}
                >
                  <step.icon className="w-8 h-8" />
                </div>
                <h3 className="font-heading text-lg font-bold text-gray-900 mb-2">
                  {step.id}. {step.title}
                </h3>
                <p className="text-sm text-gray-600 px-4">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
